import { apiCall } from "../../../../utils/apiCall";
import { header } from "../../utils/zippyAdminHeader";
import { MethodType } from "../content/faceCallTypes";

export const fetchFaceCallVideos = async () => {
  return apiCall({
    method: "GET",
    header,
    endPoint: `${process.env.REACT_APP_ZIPPY_ADMIN}/faceCall/admin/videos`
  });
};

export const fetchFaceCallVideoOptions = async () => {
  return apiCall({
    method: "GET",
    header,
    endPoint: `${process.env.REACT_APP_ZIPPY_ADMIN}/faceCall/admin/video/options`
  });
};

export const faceCallVideoMutation = async (method: MethodType, payload: any) => {
  return apiCall({
    method: method,
    header,
    endPoint: `${process.env.REACT_APP_ZIPPY_ADMIN}/faceCall/admin/video`,
    payload: payload
  });
};

export const faceCallVideoDelete = async (videoId: number) => {
  return apiCall({
    method: "DELETE",
    header,
    endPoint: `${process.env.REACT_APP_ZIPPY_ADMIN}/faceCall/admin/video/${videoId}`,
  });
};

export const fetchFaceCallSongs = async () => {
  return apiCall({
    method: "GET",
    header,
    endPoint: `${process.env.REACT_APP_ZIPPY_ADMIN}/faceCall/admin/songs`
  });
};

export const fetchFaceCallPerformers = async () => {
  return apiCall({
    method: "GET",
    header,
    endPoint: `${process.env.REACT_APP_ZIPPY_ADMIN}/faceCall/admin/performers`
  });
};

export const faceCallPerformerMutation = async (method: MethodType, payload: any) => {
  return apiCall({
    method: method,
    header,
    endPoint: `${process.env.REACT_APP_ZIPPY_ADMIN}/faceCall/admin/performer`,
    payload: payload
  });
};

export const faceCallPerformerDelete = async (performerId: number) => {
  return apiCall({
    method: "DELETE",
    header,
    endPoint: `${process.env.REACT_APP_ZIPPY_ADMIN}/faceCall/admin/performer/${performerId}`,
  });
};
